import styled from 'styled-components'

export const PreviewBackgroundGradient = () => {
  return <StyledDiv />
}

const StyledDiv = styled.div`
  background: linear-gradient(
    179.98deg,
    rgba(36, 36, 36, 0.6) 0.02%,
    rgba(0, 0, 0, 0) 51.04%
  );
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  user-select: none;
  z-index: 5;
  pointer-events: none;
`